import { createFileRoute } from '@tanstack/react-router'
import {
  ADMIN_FAQ_FILTER_KEYS,
  ADMIN_FAQ_SORT_IDS,
} from '@/features/faq/components/faq/admin-faq-columns'
import { AdminFaqPage } from '@/features/faq/pages/admin-faq-page'
import { createTableSearchSchema } from '@/lib/data-table/search-schema'

const faqSearchSchema = createTableSearchSchema({
  defaultPageSize: 20,
  sortIds: ADMIN_FAQ_SORT_IDS,
  filterKeys: ADMIN_FAQ_FILTER_KEYS,
})

export const Route = createFileRoute('/faq')({
  staticData: { title: 'Help' },
  validateSearch: faqSearchSchema,
  component: AdminFaqPage,
})
